import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule} from '@angular/core';
import {CustomElementService} from '../../../../formbird-sc-shared/src/lib/services/custom-element.service';
import {ComponentSetupModule} from '../../../../formbird-sc-shared/src/lib/component-setup.module';
import { AvlSpeedComponent } from './avl-speed.component';
import { default as pjson } from '../../../../../package.json';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatInputModule} from '@angular/material/input';


@NgModule({
  declarations: [
    AvlSpeedComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        CommonModule,
        ComponentSetupModule,
        MatFormFieldModule,
        MatTooltipModule,
        MatInputModule
    ],
  exports: [
    AvlSpeedComponent
  ],
  providers: [
  ]
})

export class AvlSpeedModule {
  constructor(private injector: Injector, private customElementService: CustomElementService ) {
    customElementService.convertToCustomElement(AvlSpeedComponent, 'sc-avl-speed', this.injector, pjson.version);

  }
}
